function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  d: "M33.53 11.38L18 2.42 2.47 11.38 18 20.35z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C386",
  strokeLinecap: "round",
  d: "M2.47 11.38L18 20.35l15.53-8.97"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  d: "M2.47 26.61L18 35.58l15.53-8.97"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  d: "M2.47 19L18 27.96 33.53 19"
}));

function SvgPlatform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 38"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzNiAzOCI+CiAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMikiPgogICAgPHBvbHlnb24gc3Ryb2tlPSIjMjNDMzg2IiBwb2ludHM9IjMxLjUzIDkuMzggMTYgLjQyIC40NyA5LjM4IDE2IDE4LjM1Ii8+CiAgICA8cG9seWxpbmUgc3Ryb2tlPSIjMjNDMzg2IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHBvaW50cz0iLjQ3IDkuMzggMTYgMTguMzUgMzEuNTMgOS4zOCIvPgogICAgPHBvbHlsaW5lIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBwb2ludHM9Ii40NyAyNC42MSAxNiAzMy41OCAzMS41MyAyNC42MSIvPgogICAgPHBvbHlsaW5lIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBwb2ludHM9Ii40NyAxNyAxNiAyNS45NiAzMS41MyAxNyIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgPlatform as ReactComponent };